<template>
    <v-file-input ref="campo"
      v-bind="attrs"
      v-model="model"
      small-chips
      multiple
      :clearable="false"
      prepend-icon=""
      :rules="rules"
      :label="labelDefault"
      v-on="$listeners"
      :data-cy="attrs.label || attrs.name">
    <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
      <slot :name="slotName" v-bind="context" />
    </template>
      <template v-for="(_, name) in $slots" v-slot:[name]>
        <slot :name="name" />
      </template>
      <template v-if="!$scopedSlots.message" v-slot:message="{ message, key }">
        <v-icon v-if="$api.UI.showErrorIcon($el)" x-small color="error" class="mr-1 pb-1">{{$theme.options.iconError}}</v-icon>
        <span v-html="message" :key="key"></span>
      </template>
    </v-file-input>
  </template>
<script>
export default {
  props: {
    value: null,
    change: Function
  },
  methods: {
    setValidationAttributes () {
      const errors = this.rules || []
      this.$el.setAttribute('data-message', errors[0] || '')
      this.$el.setAttribute('data-invalid', errors.length > 0)
    }
  },
  computed: {
    labelDefault: function () {
      return (
        this.$attrs.label ? this.$attrs.label +
      (this.$attrs.required === '' || this.$attrs.required === true ? ' *' : '')
          : ''
      )
    },
    model: {
      get () {
        return this.value
      },
      set (newFiles) {
        const existingFiles = Array.isArray(this.value) ? this.value : []
        const fileSet = new Map()
        existingFiles.forEach(file => fileSet.set(file.name, file))
        newFiles.forEach(file => fileSet.set(file.name, file))
        this.$emit('input', Array.from(fileSet.values()))
      }
    },
    attrs () {
      return { ...this.$theme.options, ...this.$theme.options.file, ...this.$attrs }
    },
    /* eslint-disable vue/return-in-computed-property */
    rules () {
      const errors = []
      const name = this.$attrs.name || this.$attrs.label || ''

      if (this.$attrs.required === '' || this.$attrs.required === true) {
        if (!this.model || this.model.length === 0) {
          errors.push(name + ' é obrigatório.')
        }
      }
      if (this.$attrs['max-files'] && this.model) {
        if (this.model.length > this.$attrs['max-files']) {
          errors.push(`Quantidade máxima de arquivos é ${this.$attrs['max-files']}.`)
        }
      }

      this.$api.UTIL.Functions.ValidateFormRules(this.$attrs.rules, errors, this.model)

      if (this.$attrs['max-size'] && this.model) {
        const maxSize = parseInt(this.$attrs['max-size'].replace(/[aA-zZ]/g, ''))
        const unit = this.$attrs['max-size'].replace(/\d/g, '').toUpperCase()

        this.model.forEach(file => {
          let fileSize = file.size

          if (unit === 'KB') fileSize /= 1024
          if (unit === 'MB') fileSize /= (1024 * 1024)
          if (unit === 'GB') fileSize /= (1024 * 1024 * 1024)
          if (file.name.length > 60) {
            errors.push(`"${file.name}" ultrapassa o limite de 60 caracteres para o nome do arquivo.`)
          }
          if (fileSize > maxSize) {
            errors.push(`${file.name}: Tamanho máximo do arquivo é de ${this.$attrs['max-size']}.`)
          }
        })
      }

      if (this.$refs && this.$refs.campo && this.$refs.campo.$el) {
        this.$refs.campo.$el.setAttribute('data-message', errors.length > 0 ? errors[0] : '')
        this.$refs.campo.$el.setAttribute('data-invalid', errors.length > 0)
      }
      return errors
    },
    mounted () {
      this.$nextTick(function () {
        this.setValidationAttributes()
      })
    }
  }
}
</script>
